import { render, staticRenderFns } from "./Wn.vue?vue&type=template&id=bd8ef3cc&scoped=true&"
import script from "./Wn.vue?vue&type=script&lang=js&"
export * from "./Wn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8ef3cc",
  null
  
)

export default component.exports